module.exports = __webpack_public_path__ + "static/img/mood11.4ea15f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods/mood11.png
// module id = 5uow
// module chunks = 1